<footer>
  <div class="justify-content-center">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <a class="branded04" (click)="go()" [routerLink]="['/']">
            <img 
              alt="Bright Cities"
              class="bright-image"
              title="Bright Cities" 
              src="assets/images/brightcities-upgrade-your-city.png"
              />
          </a>
        </div>
        <div class="col-md-6">
          <div class="footer-buttons">
            <button class="language-box" (click)="openLanguageModal()">
              <span ngClass="flag-icon flag-icon-{{ (language.current().flag == 'us') ? 'us' : 'br' }}"></span>
              <span [translate]="'navigation/change-language'">{{language.current().name}}</span>
            </button>
            <a [routerLink]="['/contact-us']" class="btn btn-gradient">{{'navigation/contact-us' | translate}}</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex menus-container">
            <div class="footer-menu">
              <div class="menu-header">
                {{'navigation/about-us' | translate}}
              </div>
              <ul>
                <li><a [routerLink]="['/about-us']">{{'navigation/about-us' | translate}}</a></li>
                <li><a [routerLink]="['/contact-us']">{{'navigation/contact-us' | translate}}</a></li>
                <li><a href="{{'navigation/press-link' | translate}}" target="_blank">{{'navigation/press' | translate}}</a></li>
                <li><a [routerLink]="['/privacy-policy']" target="_blank">{{'navigation/privacy' | translate}}</a></li>
                <li><a [routerLink]="['/anti-corruption-policy']" target="_blank">{{'navigation/anti-corruption' | translate}}</a></li>
                <li><a [routerLink]="['/faq']">FAQ</a></li>
              </ul>
            </div>
            <div class="footer-menu">
              <div class="menu-header">
                {{'navigation/cities-diagnosis' | translate}}
              </div>
              <ul>
                <li><a [routerLink]="['/cities-diagnosis']">{{'navigation/smart-cities-world-map' | translate}}</a></li>
                <li><a [routerLink]="['/solution-marketplace']">{{'navigation/world-cities-indicators' | translate}}</a>
                </li>
                <li><a href="https://leadingcities.org/leading-cities-rating/"
                    target="_blank">{{'navigation/rating-system' | translate}}</a></li>
              </ul>
            </div>
            <div class="footer-menu">
              <div class="menu-header">
                {{'navigation/solutions-marketplace' | translate}}
              </div>
              <ul>
                <li><a [routerLink]="['/smart-cities-solutions']">{{'painel-dashboard/solutions' | translate}}</a></li>
                <li><a [routerLink]="['/smart-cities-suppliers']">{{'painel-dashboard/suppliers' | translate}}</a></li>
                <li><a [routerLink]="['/solution-marketplace']"
                    [queryParams]="{scroll: 'opportunities'}">{{'contact-us/opportunities-for-suppliers' | translate}}</a>
                </li>
              </ul>
            </div>
            <div class="footer-menu">
              <div class="menu-header">
                {{'navigation/our-services' | translate}}
              </div>
              <ul>
                <li><a [routerLink]="['/our-services/public-administrator']" (click) = "go()" >{{'our-services/public-administrator' | translate}}</a></li>
                <li><a [routerLink]="['/our-services/solution-provider']" (click) = "go()" >{{'navigation/solution-provider' | translate}}</a></li>
                <li><a [routerLink]="['/our-services/connected-citizen']" (click) = "go()" >{{'navigation/connected-citizen' | translate}}</a></li>
              </ul>
            </div>
            <div class="footer-menu">
              <div class="menu-header">
                {{'landing/content-trends' | translate}}
              </div>
              <ul>
                <li><a
                    href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '' : '/pt-br/' }}">{{'landing/blog' | translate}}</a>
                </li>
                <li><a href="{{'navigation/in-the-news-link' | translate}}"
                    target="_blank">{{'navigation/in-the-news' | translate}}</a></li>
                <!-- <li><a href="">Smart Cities</a></li>
                                <li><a href="">Covid-19</a></li>
                                <li><a href="">Cases</a></li>
                                <li><a href="">SDG - Sustainable</a></li> -->
              </ul>
            </div>
            <div class="sponsor">
              <!-- <a href="http://www.itau.com.br/" target="_blank" class="text-center">
                <span class="grey01" [translate]="'footer/sponsor'">Sponsor</span>
                <img title="Itau" alt="Itau" src="../assets/images/logo-itau.png" />
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container gray-line">
    <div class="bottom-footer">
      <div class="row">
        <div class="col-md-4">
          <div class="rights-reserved" [translate]="'footer/allrights'">All Rights Reserved Bright Cities @ 2021</div>
        </div>
        <div class="col-md-4">
          <ul class="social-list">
            <li>
              <a href="https://facebook.com/brightcities1/" target="_blank"><i class="fab fa-facebook"></i></a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/bright-cities" target="_blank"><i
                  class="fab fa-linkedin"></i></a>
            </li>
            <li>
              <a href="https://www.instagram.com/bright_cities_/?hl=pt-br" target="_blank"><i
                  class="fab fa-instagram"></i></a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCTQ8dVac6BDWP1_P6A3VSGw" target="_blank"><i
                  class="fab fa-youtube"></i></a>
            </li>
            <li>
              <a href="https://twitter.com/bright_cities_" target="_blank"><i class="fab fa-twitter"></i></a>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="partner-list">
            <!-- <li>
              <a href="https://blog.brightcities.city/sdgs/" target="_blank">
                <img alt="ONU" src="../assets/images/logo/logo-ods-footer.png" height="26" width="176" />
              </a>
            </li> -->
            <li>
              <a>
                <img title="Gov Tech" alt="Gov Tech" src="../assets/images/gov-tech.png" height="48" width="107" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>